<template>
  <div class="popup z-index-10-fg confirmation small-popup reminder-popup">
    <div class="popup-content">
      <div class="popup-header">
        <h2>Reminder</h2>
        <img src="../assets/close.svg" alt="" class="popup-close" @click="$emit('closePopup')" />
      </div>
      <div class="popup-info">
        <p>{{ formatDate(reminder.DATE) }} - Type: {{ reminder.TYPE }}</p>
      </div>
      <div class="popup-body">
        <p v-if="reminder.company" class="title" @click="openContact(reminder)">{{ reminder.company.NAME }} <img src="../assets/external-link.svg" /></p>
        <p v-if="reminder.contact" class="title" @click="openContact(reminder)">{{ reminder.contact.FIRSTNAME }} {{ reminder.contact.LASTNAME }} <img src="../assets/external-link.svg" /></p>
        <p
          v-if="reminder.lead"
          class="title"
          @click="
            showSingleLead = reminder.lead.LEADID;
            $emit('closePopup');
          ">
          {{ reminderLeadName(reminder) }} Lead<img src="../assets/external-link.svg" />
        </p>

        <p class="text">{{ reminder.TEXT }}</p>
      </div>
      <div class="popup-footer">
        <button @click="$emit('closePopup')" class="text-btn">close</button>

        <button @click="completeReminder()" class="square-btn">Complete</button>
      </div>
    </div>
  </div>
  <div class="screen-overlay-gray z-index-10-bg"></div>
</template>

<script>
import useReminderMutate from '../composables/useReminderMutate';
import useSingleLeadQuery from '@/composables/useSingleLeadQuery';

export default {
  name: 'Reminder',
  emits: ['closePopup'],
  props: {
    reminderid: String,
    reminders: Array,
  },
  setup() {
    const { updateReminder } = useReminderMutate();
    const { showSingleLead } = useSingleLeadQuery;

    return { updateReminder, showSingleLead };
  },
  computed: {
    reminder() {
      return this.reminders.find((reminder) => reminder.REMINDERID === this.reminderid);
    },
  },
  methods: {
    completeReminder() {
      this.updateReminder(this.reminder.REMINDERID, { COMPLETED: true });
      this.$emit('closePopup');
    },
    openContact(reminder) {
      if (reminder.company) {
        this.$router.push({ name: 'companies', params: { companyid: reminder.company.COMPANYID } });
        this.$emit('closePopup');
      } else {
        this.$router.push({ name: 'contacts', params: { contactid: reminder.contact.CONTACTID } });
        this.$emit('closePopup');
      }
    },
    formatDate(date) {
      const today = new Date();
      const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      const twoDaysAgo = new Date(today);
      twoDaysAgo.setDate(today.getDate() - 2);
      const threeDaysAgo = new Date(today);
      threeDaysAgo.setDate(today.getDate() - 3);
      const fourDaysAgo = new Date(today);
      fourDaysAgo.setDate(today.getDate() - 4);
      const fiveDaysAgo = new Date(today);
      fiveDaysAgo.setDate(today.getDate() - 5);
      const sixDaysAgo = new Date(today);
      sixDaysAgo.setDate(today.getDate() - 6);
      const sevenDaysAgo = new Date(today);
      sevenDaysAgo.setDate(today.getDate() - 7);

      const reminderDate = new Date(parseInt(date));

      if (reminderDate.toDateString() === today.toDateString()) {
        return `Today, ${reminderDate.getMonth() + 1}/${reminderDate.getDate()}/${reminderDate.getFullYear()}`;
      } else if (reminderDate.toDateString() === yesterday.toDateString()) {
        return `Yesterday, ${reminderDate.getMonth() + 1}/${reminderDate.getDate()}/${reminderDate.getFullYear()}`;
      } else if (reminderDate.toDateString() === twoDaysAgo.toDateString()) {
        return `Last ${weekdays[reminderDate.getDay()]}, ${reminderDate.getMonth() + 1}/${reminderDate.getDate()}/${reminderDate.getFullYear()}`;
      } else if (reminderDate.toDateString() === threeDaysAgo.toDateString()) {
        return `Last ${weekdays[reminderDate.getDay()]}, ${reminderDate.getMonth() + 1}/${reminderDate.getDate()}/${reminderDate.getFullYear()}`;
      } else if (reminderDate.toDateString() === fourDaysAgo.toDateString()) {
        return `Last ${weekdays[reminderDate.getDay()]}, ${reminderDate.getMonth() + 1}/${reminderDate.getDate()}/${reminderDate.getFullYear()}`;
      } else if (reminderDate.toDateString() === fiveDaysAgo.toDateString()) {
        return `Last ${weekdays[reminderDate.getDay()]}, ${reminderDate.getMonth() + 1}/${reminderDate.getDate()}/${reminderDate.getFullYear()}`;
      } else if (reminderDate.toDateString() === sixDaysAgo.toDateString()) {
        return `Last ${weekdays[reminderDate.getDay()]}, ${reminderDate.getMonth() + 1}/${reminderDate.getDate()}/${reminderDate.getFullYear()}`;
      } else if (reminderDate.toDateString() === sevenDaysAgo.toDateString()) {
        return `Last ${weekdays[reminderDate.getDay()]}, ${reminderDate.getMonth() + 1}/${reminderDate.getDate()}/${reminderDate.getFullYear()}`;
      } else {
        return `${reminderDate.getMonth() + 1}/${reminderDate.getDate()}/${reminderDate.getFullYear()}`;
      }
    },
    reminderLeadName(reminder) {
      if (reminder.lead.company) {
        return reminder.lead.company.NAME;
      } else if (reminder.lead.contact) {
        return `${reminder.lead.contact.FIRSTNAME} ${reminder.lead.contact.LASTNAME}`;
      } else {
        return reminder.lead.NAME;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.reminder-popup {
  width: 30rem;

  .popup-info {
    p {
      font-size: $fontSize13;
      margin: 0;
      color: $textColor38;
    }
  }

  .popup-body {
    .title {
      font-size: $fontSize16;
      margin: 0;
      display: flex;
      align-items: center;

      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
      img {
        margin-left: 0.5rem;
      }
    }

    .text {
      font-size: $fontSize13;
      margin: 1rem 0;
    }
  }
}
</style>
